import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Verifies the session by hitting /api/auth/me (cookie is sent automatically).
 * Shows nothing while checking, redirects to /login if unauthenticated.
 */
export default function ProtectedRoute({ children, allowedRoles }) {
    const [state, setState] = useState('checking'); // checking | ok | denied

    useEffect(() => {
        fetch('/api/auth/me', { credentials: 'include' })
            .then(async (res) => {
                if (!res.ok) { setState('denied'); return; }
                const data = await res.json();
                // Sync role/name for UI use
                localStorage.setItem('trf_role', data.role);
                localStorage.setItem('trf_name', data.name);
                if (allowedRoles && !allowedRoles.includes(data.role)) {
                    setState('wrong-role');
                } else {
                    setState('ok');
                }
            })
            .catch(() => setState('denied'));
    }, []);

    if (state === 'checking') {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: 'var(--off-white)' }}>
                <span className="trf-spinner" style={{ width: '2rem', height: '2rem' }} />
            </div>
        );
    }
    if (state === 'denied')     return <Navigate to="/login" replace />;
    if (state === 'wrong-role') {
        const role = localStorage.getItem('trf_role');
        return <Navigate to={role === 'desk' ? '/desk' : '/doctor'} replace />;
    }
    return children;
}
